function CaseBlock({ caseBlockItem, tags = [], links = [] }) {
  const { src, textTitle, title, tag, textDescription, textLink, id } =
    caseBlockItem;
  console.log(links);
  return (
    <div className="caseBlock" key={id}>
      <div className="caseBlockImg">
        <img src={src} alt="image" />
      </div>
      <div className="caseBlockDescription">
        <div className="caseBlockTitle">
          <p>{textTitle}</p>
          <h3>{title}</h3>
        </div>
        <div className="caseBlockTags">
          {tags?.map((tag, index) => (
            <span>{tag}</span>
          ))}
        </div>
        <p>{textDescription}</p>
        <div className="caseBlockLinks">
          {links?.map(({ textLink, hrefLink, id }) => (
            <a href={hrefLink} key={id}>
              {textLink}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CaseBlock;
